import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateNoSalaryForm } from "../../../components/create-no-salary-leave-form";

export const NoSalaryCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin nghỉ không lương">
      <CreateNoSalaryForm />
    </ProcedureLayout>
  );
});
